import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    userInfo: {
      id: '',
      icon: '',
      phone: '',
      username: '',
      uuid: '',
      tenant_number: '',
      type: ''
    }
  },
  mutations: {
    SET_USER (state, value) {
      Vue.set(state.userInfo, 'id', value.id)
      Vue.set(state.userInfo, 'icon', value.icon)
      Vue.set(state.userInfo, 'phone', value.phone)
      Vue.set(state.userInfo, 'username', value.username)
      Vue.set(state.userInfo, 'uuid', value.uuid)
      Vue.set(state.userInfo, 'tenant_number', value.tenant_number)
      Vue.set(state.userInfo, 'type', value.type)
      // state.userInfo = value;
    },
  },
  actions: {
    setUser ({ commit }, value) {
      commit('SET_USER', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js